import { useMemo, useState } from 'react';
import styled from 'styled-components';
import { Container, Section, SectionTitle, SectionSubtitle, Grid } from '../components/ui/Layout';
import MenuItemCard from '../components/MenuItemCard';
import Reveal from '../components/ui/Reveal';
import MENU from '../data/menu';

const Tabs = styled.div`
  display: flex;
  gap: 0.6rem;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 2.5rem;
`;

const Tab = styled.button`
  min-height: 44px;
  padding: 0.6em 1.3em;
  border-radius: ${({ theme }) => theme.radii.sm};
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.heading};
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 500;
  font-size: 0.85rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  color: ${({ theme, $active }) => ($active ? theme.colors.bgDarker : theme.colors.textMuted)};
  background: ${({ theme, $active }) => ($active ? theme.gradients.primary : 'transparent')};
  box-shadow: ${({ theme, $active }) => ($active ? theme.glow.gold : 'none')};
  transition: all 200ms ease;

  &:hover {
    color: ${({ theme, $active }) => ($active ? theme.colors.bgDarker : theme.colors.gold)};
    border-color: ${({ theme }) => theme.colors.gold};
    transform: translateY(-2px);
  }
`;

function Menu() {
  const [activeId, setActiveId] = useState(MENU[0]?.id ?? null);

  const activeCategory = useMemo(
    () => MENU.find((c) => c.id === activeId),
    [activeId]
  );

  return (
    <Section>
      <Container>
        <Reveal>
          <SectionTitle>Nuestro Menú</SectionTitle>
          <SectionSubtitle>
            Cocteles, cervezas, mezcales y botanas para acompañar cualquier etapa del duelo.
          </SectionSubtitle>
        </Reveal>

        <Tabs role="tablist" aria-label="Categorías del menú">
          {MENU.map((cat) => (
            <Tab
              key={cat.id}
              role="tab"
              type="button"
              aria-selected={cat.id === activeId}
              $active={cat.id === activeId}
              onClick={() => setActiveId(cat.id)}
            >
              {cat.nombre}
            </Tab>
          ))}
        </Tabs>

        {activeCategory && (
          <Grid $min="260px" role="tabpanel">
            {activeCategory.items.map((item, i) => (
              <Reveal key={item.id} delay={(i % 6) * 70} variant="scale">
                <MenuItemCard item={item} />
              </Reveal>
            ))}
          </Grid>
        )}
      </Container>
    </Section>
  );
}

export default Menu;
